let stores = [
  {
    Shop: 'Nestlé Shop Würenlos',
    'Opening Hours': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-21:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop Würenlos', 'Shopping-Raststätte Würenlos', '5436 Würenlos'],
    LatLong: {
      lat: 47.4207,
      lng: 8.3196,
    },
  },
  {
    Shop: 'Nestlé Shop Bergère',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00-18:30',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00-10:00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop Bergère', 'Av. Nestlé 55 1800 Vevey'],
    LatLong: {
      lat: 46.4623,
      lng: 6.8483,
    },
  },
  {
    Shop: 'Nestlé Shop La Tour',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:00-18:30',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00-16:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00-12:00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop La Tour', 'Rue Entre-deux-Villes 10', 'CP 352, 1814 La Tour-de-Peilz'],
    LatLong: {
      lat: 46.4555,
      lng: 6.8682,
    },
  },
  {
    Shop: 'Nestlé Shop CRN',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00-18:30',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:00-12:00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop CRN', 'Centre de Recherches', '1000 Lausanne 26'],
    LatLong: {
      lat: 46.5196,
      lng: 6.5855,
    },
  },
  {
    Shop: 'Nestlé Shop Henniez',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:30-17:30',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:30-12:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:30-12:00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop Henniez', 'Route de la Gare 1', '1525 Henniez'],
    LatLong: {
      lat: 46.7504,
      lng: 6.8666,
    },
  },
  {
    Shop: 'Nestlé Shop Broc',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00-18:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00-16:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:30-12:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:30-12:00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop / Fabrique de Broc ', 'Rue Jules Bellet 7', '1636 Broc'],
    LatLong: {
      lat: 46.6157,
      lng: 7.0848,
    },
  },
  {
    Shop: 'Nestlé Shop Orbe',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00-18:30',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00-17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:30-10:00 & 14:00-16:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:30-10:00 & 14:00-16h00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop Orbe', 'Route de Chavornay 1', '1350 Orbe'],
    LatLong: {
      lat: 46.725,
      lng: 6.5349,
    },
  },
  {
    Shop: 'Nestlé Shop Crissier',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00-18:30',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00-17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09h00-10:00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop Crissier', 'Chemin de l´Esparcette 5', '1023 Crissier'],
    LatLong: {
      lat: 46.5475,
      lng: 6.5623,
    },
  },
  {
    Shop: 'Nestlé Shop Morges',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00-18:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00-17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '08:30-12:00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop Morges', 'Rue de Lausanne 54', '1110 Morges'],
    LatLong: {
      lat: 46.5154,
      lng: 6.4982,
    },
  },
  {
    Shop: 'Nestlé Shop Rorschach',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00-18:30',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00-16:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Nestlé Shop Rorschach', 'Blumenfeldstrasse 8', '9400 Rorschach'],
    LatLong: {
      lat: 47.474382956173386,
      lng: 9.481434541858302,
    },
  },
  {
    Shop: 'Nestlé Shop Kemptthal',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00-18:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00-16:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00-11:30 & 13:00-16:00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop Kemptthal', 'The Valley, Kemptpark 12', '8310 Kemptthal'],
    LatLong: {
      lat: 47.3979,
      lng: 8.6402,
    },
  },
  {
    Shop: 'Nestlé Shop Konolfingen',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00-18:30',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00-16:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00-11:30 & 13:00-16:00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop  Konolfingen', 'Burgdorfstrasse 1', '3510 Konolfingen'],
    LatLong: {
      lat: 46.85,
      lng: 7.65,
    },
  },
  {
    Shop: 'Nestlé Shop Wangen',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00-18:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00-16:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00-15:00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop ', 'Industriestrasse 14', '4612 Wangen'],
    LatLong: {
      lat: 47.28,
      lng: 7.8,
    },
  },
  {
    Shop: 'Nestlé Shop Landquart',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00-18:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00-16:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00-14:00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop Landquart', 'Weststr. 1', '7302 Landquart'],
    LatLong: {
      lat: 46.95,
      lng: 9.55,
    },
  },
  {
    Shop: 'Nestlé Shop Lausen',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00-18:30',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00-16:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00-16:00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop Lausen', 'Saarbaumstr. 1', '4415 Lausen'],
    LatLong: {
      lat: 47.45,
      lng: 7.75,
    },
  },
  {
    Shop: 'Nestlé Shop Niederhasli',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00-18:30',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00-17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag bis Samstag',
        Uhrzeit: '08:30-11:30 & 13:00-16:00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop Niederhasli', 'Mandachstrasse 54-56', '8155 Niederhasli'],
    LatLong: {
      lat: 47.45,
      lng: 8.45,
    },
  },
  {
    Shop: 'Nestlé Shop Spreitenbach',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00-18:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00-17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag bis Samstag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop Spreitenbach', 'Industriestrasse 174', '8957 Spreitenbach'],
    LatLong: {
      lat: 47.4,
      lng: 8.4,
    },
  },
  {
    Shop: 'Nestlé Shop Cham',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00-18:30',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00-17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag bis Samstag',
        Uhrzeit: '09:00-16:00',
      },
    ],
    Address: ['Nestlé Suisse SA', 'Nestlé Shop CHAM', 'Zugerstrasse 6d', '6330 CHAM'],
    LatLong: {
      lat: 47.1833,
      lng: 8.4667,
    },
  },
  {
    Shop: 'Manor Basel',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Greifengasse 22', '4005 Basel'],
    LatLong: {
      lat: 47.5611,
      lng: 7.5926,
    },
  },
  {
    Shop: 'Manor Ascona-Delta',
    'Opening Hours': [
      {
        Tag: 'Montag, Dienstag, Mittwoch, Freitag',
        Uhrzeit: '08:30 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '08:30 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:30 - 18:30',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Via Ferrera', '6612 Ascona'],
    LatLong: {
      lat: 46.1628,
      lng: 8.775,
    },
  },
  {
    Shop: 'Manor Baden Warenhaus',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:30 - 19:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Schlossbergplatz 7', '5400 Baden'],
    LatLong: {
      lat: 47.4736,
      lng: 8.3069,
    },
  },
  {
    Shop: 'Manor Balerna',
    'Opening Hours': [
      {
        Tag: 'Montag - Mitwoch, Freitag',
        Uhrzeit: '08:30 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '08:30 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:30 - 18:30',
      },
      {
        Tag: 'Sonntag',
        Uhrzeit: '0:00 - 0:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Via San Gottardo 56A', '6828 Balerna'],
    LatLong: {
      lat: 45.8463,
      lng: 9.012,
    },
  },
  {
    Shop: 'Manor Biel',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch, Freitag ',
        Uhrzeit: '09:00 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '09:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:30 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Zentralstrasse 40', '2502 Biel'],
    LatLong: {
      lat: 47.1375,
      lng: 7.2458,
    },
  },
  {
    Shop: 'Manor Chavannes',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag, Samstag',
        Uhrzeit: '09:00 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '09:00 - 21:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Chemin Industriel', '1279 Chavannes-de-Bogis'],
    LatLong: {
      lat: 46.334,
      lng: 6.1572,
    },
  },
  {
    Shop: 'Manor Chur',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:30 - 19:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Bahnhofstrasse 32', '7000 Chur'],
    LatLong: {
      lat: 46.8513,
      lng: 9.5302,
    },
  },
  {
    Shop: 'Manor Delémont',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch, Freitag',
        Uhrzeit: '08:00 - 18:30',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '09:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Avenue de la Gare 27', '2800 Delemont'],
    LatLong: {
      lat: 47.3645,
      lng: 7.3496,
    },
  },
  {
    Shop: 'Manor Emmen',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '09:00 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '09:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Stauffacherstrasse 1', '6020 Emmen'],
    LatLong: {
      lat: 47.0742,
      lng: 8.2873,
    },
  },
  {
    Shop: 'Manor Fribourg',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '09:00 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '09:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:30 - 16:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Rue de Romont 30', '1700 Fribourg'],
    LatLong: {
      lat: 46.804,
      lng: 7.1537,
    },
  },
  {
    Shop: 'Manor Genève',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch',
        Uhrzeit: '09:00 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '09:00 - 21:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '09:00 - 19:30',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:30 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Rue Cornavin 6', '1201 Genève'],
    LatLong: {
      lat: 46.2075,
      lng: 6.1424,
    },
  },
  {
    Shop: 'Manor Lausanne',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00 - 19:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Rue Pichard 3', '1003 Lausanne'],
    LatLong: {
      lat: 46.5223,
      lng: 6.6314,
    },
  },
  {
    Shop: 'Manor Lugano',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch, Freitag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '08:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:30',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Salita Chiattone 10', '6900 Lugano'],
    LatLong: {
      lat: 46.0055,
      lng: 8.9502,
    },
  },
  {
    Shop: 'Manor Marin',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch',
        Uhrzeit: '09:00 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '09:00 - 20:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '09:00 - 19:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Champs-Montants 2', '2074 Marin-Epagnier'],
    LatLong: {
      lat: 47.0126,
      lng: 6.9958,
    },
  },
  {
    Shop: 'Manor Monthey',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '09:00 - 18:30',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '09:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Av. de l`Europe 21', '1870 Monthey (Centre Commercial)'],
    LatLong: {
      lat: 46.2617,
      lng: 6.9468,
    },
  },
  {
    Shop: 'Manor Morges',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '09:00 - 18:45',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '09:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Grand-Rue 46', '1110 Morges'],
    LatLong: {
      lat: 46.5099,
      lng: 6.4984,
    },
  },
  {
    Shop: 'Manor Nyon',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00 - 19:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Rue de la Gare 35', '1260 Nyon'],
    LatLong: {
      lat: 46.3832,
      lng: 6.2369,
    },
  },
  {
    Shop: 'Manor Rapperswil',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00 - 19:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Neue Jonastrasse 20', '8640 Rapperswil'],
    LatLong: {
      lat: 47.2267,
      lng: 8.8193,
    },
  },
  {
    Shop: 'Manor San Antonino',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch, Freitag ',
        Uhrzeit: '09:00 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '09:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:30',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Via Industrie 3', '6592 San Antonino'],
    LatLong: {
      lat: 46.1561,
      lng: 8.9665,
    },
  },
  {
    Shop: 'Manor Sargans',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:30 - 19:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Grossfeldstrasse', '7320 Sargans'],
    LatLong: {
      lat: 47.0466,
      lng: 9.4387,
    },
  },
  {
    Shop: 'Manor Sierre',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '09:00 - 18:30',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '09:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Centre Manor Sierre', '3960 Sierre'],
    LatLong: {
      lat: 46.2824,
      lng: 7.5112,
    },
  },
  {
    Shop: 'Manor Sion',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 18:30',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Avenue du Midi 3', '1951 Sion'],
    LatLong: {
      lat: 46.231,
      lng: 7.3588,
    },
  },
  {
    Shop: 'Manor St. Gallen',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch, Freitag ',
        Uhrzeit: '09:00 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '09:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Waisenhausstrasse 5', '9000 St. Gallen'],
    LatLong: {
      lat: 47.4244,
      lng: 9.373,
    },
  },
  {
    Shop: 'Manor Vesenaz',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Donnerstag - Freitag',
        Uhrzeit: '08:00 - 19:30',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Route de Thonon 40', '1222 Vesenaz'],
    LatLong: {
      lat: 46.2382,
      lng: 6.1965,
    },
  },
  {
    Shop: 'Manor Vevey',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '09:00 - 18:30',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '09:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Av. Géneral Guisan 1', '1800 Vevey'],
    LatLong: {
      lat: 46.4631,
      lng: 6.8411,
    },
  },
  {
    Shop: 'Manor Vezia',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '09:00 - 18:30',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '09:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Via S. Gottardo 34', '6943 Vezia'],
    LatLong: {
      lat: 46.0265,
      lng: 8.9375,
    },
  },
  {
    Shop: 'Manor Yverdon',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00 - 18:30',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:30 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Rue du Lac 31', '1400 Yverdon-les-Bains'],
    LatLong: {
      lat: 46.7803,
      lng: 6.6386,
    },
  },
  {
    Shop: 'Nestlé Shop Konolfingen',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00 - 18:30',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '09:00 - 14:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 10:00',
      },
    ],
    Address: ['Burgdorfstrasse 1', '3510 Konolfingen'],
    LatLong: {
      lat: 46.8811,
      lng: 7.6211,
    },
  },
  {
    Shop: 'Coop Supermarkt Kaiseraugst',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:30 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Junkholzweg 3', '4303 Kaiseraugst'],
    LatLong: {
      lat: 47.5381,
      lng: 7.7318,
    },
  },
  {
    Shop: 'Coop Supermarkt M\u00f6hlin',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '07:30 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Hauptstrasse 9', '4313 M\u00f6hlin'],
    LatLong: {
      lat: 47.5635,
      lng: 7.8423,
    },
  },
  {
    Shop: 'Coop Supermarkt Netstal Wiggispark',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:30 - 20:00',
      },
      {
        Tag: 'Samstag ',
        Uhrzeit: '08:00 - 19:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Molliserstrasse 41', '8754 Netstal'],
    LatLong: {
      lat: 47.0682,
      lng: 9.0578,
    },
  },
  {
    Shop: 'Coop Supermarkt City Z\u00fcrich St. Annahof Food',
    'Opening Hours': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 20:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Bahnhofstrasse 57', '8001 Z\u00fcrich'],
    LatLong: {
      lat: 47.3729,
      lng: 8.538,
    },
  },
  {
    Shop: 'Coop Supermarkt City Lausanne Au Centre Food',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Samstag ',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Rue Saint-Laurent 24-30', '1003 Lausanne'],
    LatLong: {
      lat: 46.5229,
      lng: 6.6305,
    },
  },
  {
    Shop: 'Coop Supermarkt Wohlen',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag ',
        Uhrzeit: '07:30 - 20:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Alte Bahnhofstrasse 2-6', '5610 Wohlen'],
    LatLong: {
      lat: 47.3505862,
      lng: 8.2707,
    },
  },
  {
    Shop: 'Coop Supermarkt Zofingen',
    'Opening Hours': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '07:30 - 20:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Aarburgerstrasse 4', '4800 Zofingen'],
    LatLong: {
      lat: 47.2923,
      lng: 7.9426,
    },
  },
  {
    Shop: 'Coop Supermarkt M\u00fcnchenstein Gartenstadt',
    'Opening Hours': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '07:00 - 20:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['St\u00f6ckackerstrasse 8', '4142 M\u00fcnchenstein'],
    LatLong: {
      lat: 47.5214,
      lng: 7.6077,
    },
  },
  {
    Shop: 'Coop Supermarkt Frick',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag ',
        Uhrzeit: '07:30 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Hauptstrasse 37', '5070 Frick'],
    LatLong: {
      lat: 47.5092,
      lng: 8.0192,
    },
  },
  {
    Shop: 'Coop Supermarkt Bern Bethlehem',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 21:00',
      },
      {
        Tag: 'Samstag ',
        Uhrzeit: '07:30 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Kasparstrasse 7/9', '3027 Bern'],
    LatLong: {
      lat: 46.9514,
      lng: 7.392,
    },
  },
  {
    Shop: 'Coop Supermarkt Schwarzenburg',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag ',
        Uhrzeit: '07:30 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Bernstrasse 10', '3150 Schwarzenburg'],
    LatLong: {
      lat: 46.8198,
      lng: 7.3419,
    },
  },
  {
    Shop: 'Coop Supermarkt Volketswil Volkiland',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Sonntag',
        Uhrzeit: '10:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Industriestrasse 1', '8604 Volketswil'],
    LatLong: {
      lat: 47.3827,
      lng: 8.6673,
    },
  },
  {
    Shop: 'Coop Supermarkt Schlieren Lilie',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag ',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Z\u00fcrcherstrasse 6', '8952 Schlieren'],
    LatLong: {
      lat: 47.3975,
      lng: 8.4488,
    },
  },
  {
    Shop: 'Coop Supermarkt Reinach AG',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch',
        Uhrzeit: '07:30 - 19:00',
      },
      {
        Tag: 'Donnerstag - Samstag ',
        Uhrzeit: '07:30 - 20:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Obere Stumpenbachstrasse 10', '5734 Reinach'],
    LatLong: {
      lat: 47.2518,
      lng: 8.1823,
    },
  },
  {
    Shop: 'Coop Supermarkt Lenzburg',
    'Opening Hours': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '07:30 - 20:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Augustin-Keller-Strasse 31', '5600 Lenzburg'],
    LatLong: {
      lat: 47.39,
      lng: 8.1708,
    },
  },
  {
    Shop: 'Coop Supermarkt Affoltern am Albis',
    'Opening Hours': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '08:00 - 20:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['B\u00fcelstrasse 15', '8910 Affoltern am Albis'],
    LatLong: {
      lat: 47.274,
      lng: 8.4456,
    },
  },
  {
    Shop: 'Coop Supermarkt Z\u00fcrich Letzipark',
    'Opening Hours': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '09:00 - 20:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Baslerstrasse 50', '8048 Z\u00fcrich'],
    LatLong: {
      lat: 47.3862,
      lng: 8.4983,
    },
  },
  {
    Shop: 'Coop Supermarkt Herzogenbuchsee',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '07:30 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Bernstrasse 43', '3360 Herzogenbuchsee'],
    LatLong: {
      lat: 47.1858,
      lng: 7.7034,
    },
  },
  {
    Shop: 'Coop Supermarkt City Sion Food',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 18:30',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Rue de Scex 2', '1950 Sion'],
    LatLong: {
      lat: 46.2317,
      lng: 7.3628,
    },
  },
  {
    Shop: 'Coop Supermarkt City Bern Ryfflihof Food',
    'Opening Hours': [
      {
        Tag: 'Montag',
        Uhrzeit: '09:00 - 19:00',
      },
      {
        Tag: 'Dienstag, Mittwoch',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Donnerstag, Freitag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Aarbergergasse 53', '3011 Bern'],
    LatLong: {
      lat: 46.9497,
      lng: 7.4417,
    },
  },
  {
    Shop: 'Coop Supermarkt Lausanne Caroline',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '07:30 - 19:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '07:30 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Rue Caroline 6', '1003 Lausanne'],
    LatLong: {
      lat: 46.5208,
      lng: 6.6376,
    },
  },
  {
    Shop: 'Coop Supermarkt Uzwil',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '07:30 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Wattstrasse 1', '9240 Uzwil'],
    LatLong: {
      lat: 47.4363,
      lng: 9.139,
    },
  },
  {
    Shop: 'Coop Supermarkt Biel Bahnhof',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '07:30 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Salzhausstrasse 31', '2503 Biel'],
    LatLong: {
      lat: 47.1306,
      lng: 7.2427,
    },
  },
  {
    Shop: 'Coop Supermarkt Gen\u00e8ve Eaux-Vives',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch',
        Uhrzeit: '07:30 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '07:30 - 21:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '07:30 - 19:30',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '07:30 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Rue Jargonnant 5', '1207 Gen\u00e8ve'],
    LatLong: {
      lat: 46.2008,
      lng: 6.1601,
    },
  },
  {
    Shop: 'Coop Supermarkt Frauenfeld Schlosspark',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Z\u00fcrcherstrasse 138', '8500 Frauenfeld'],
    LatLong: {
      lat: 47.5544,
      lng: 8.8963,
    },
  },
  {
    Shop: 'Coop Supermarkt Winterthur Gr\u00fczemarkt',
    'Opening Hours': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '08:00 - 20:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Rudolf Diesel-Strasse 19', '8404 Winterthur'],
    LatLong: {
      lat: 47.4947,
      lng: 8.7577,
    },
  },
  {
    Shop: 'Coop Supermarkt Signy',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:30 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:30 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 19:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Rue des Fl\u00e9ch\u00e8res 7a', '1274 Signy'],
    LatLong: {
      lat: 46.3974,
      lng: 6.2059,
    },
  },
  {
    Shop: 'Coop Supermarkt St. Gallen Gallusmarkt',
    'Opening Hours': [
      {
        Tag: 'Montag- Mittwoch, Freitag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '08:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Favrestrasse 6', '9016 St. Gallen'],
    LatLong: {
      lat: 47.4381,
      lng: 9.4129,
    },
  },
  {
    Shop: 'Coop Supermarkt Bern B\u00fcmpliz',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '07:30 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Br\u00fcnnenstrasse 118', '3018 Bern'],
    LatLong: {
      lat: 46.9416,
      lng: 7.3915,
    },
  },
  {
    Shop: 'Coop Supermarkt Brig',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '07:30 - 18:30',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '07:30 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '07:30 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Gliserallee 13', '3900 Brig'],
    LatLong: {
      lat: 46.315,
      lng: 7.9865,
    },
  },
  {
    Shop: 'Coop Supermarkt Z\u00fcrich Eleven',
    'Opening Hours': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '07:30 - 21:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Sophie-Taeuber-Strasse 4', '8050 Z\u00fcrich'],
    LatLong: {
      lat: 47.4131,
      lng: 8.5406,
    },
  },
  {
    Shop: 'Coop Supermarkt Crissier',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:30 - 19:30',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:30 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Chemin de Saugy 1', '1023 Crissier'],
    LatLong: {
      lat: 46.5448,
      lng: 6.5704,
    },
  },
  {
    Shop: 'Coop Supermarkt Grand-Lancy',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch',
        Uhrzeit: '07:30 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '07:30 - 20:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '07:30 - 19:30',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '07:30 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Place du 1er Ao\u00fbt 1', '1212 Grand-Lancy'],
    LatLong: {
      lat: 46.182,
      lng: 6.1203,
    },
  },
  {
    Shop: 'Coop Supermarkt Biberist',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 18:30',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '07:30 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Hauptstrasse 44', '4562 Biberist'],
    LatLong: {
      lat: 47.182,
      lng: 7.5637,
    },
  },
  {
    Shop: 'Coop Supermarkt Chur Quader',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Quaderstrasse 36', '7000 Chur'],
    LatLong: {
      lat: 46.8526,
      lng: 9.5354,
    },
  },
  {
    Shop: 'Coop Supermarkt Grenchen Zentrum',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '07:00 - 18:30',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '07:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '07:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Solothurnstrasse 20', '2540 Grenchen'],
    LatLong: {
      lat: 47.1923,
      lng: 7.3974,
    },
  },
  {
    Shop: 'Coop Supermarkt Avenches Milavy',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['En Milavy', '1580 Avenches'],
    LatLong: {
      lat: 46.8776,
      lng: 7.0318,
    },
  },
  {
    Shop: 'Coop Supermarkt W\u00fcrenlingen Aarepark',
    'Opening Hours': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '08:00 - 20:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Kuhg\u00e4sslistrasse 7', '5303 W\u00fcrenlingen'],
    LatLong: {
      lat: 47.5251,
      lng: 8.2443,
    },
  },
  {
    Shop: 'Coop Supermarkt Wettingen T\u00e4gipark',
    'Opening Hours': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '08:00 - 20:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Jurastrasse 42-46', '5430 Wettingen'],
    LatLong: {
      lat: 47.4584,
      lng: 8.3293,
    },
  },
  {
    Shop: 'Muri AG',
    'Opening Hours': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '07:30 - 20:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Seetalstrasse 1', '5630 Muri'],
    LatLong: {
      lat: 47.2727,
      lng: 8.3409,
    },
  },
  {
    Shop: 'Coop Supermarkt Tenero',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch, Freitag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '08:00 - 21:00',
      },
      {
        Tag: 'Samstag ',
        Uhrzeit: '08:00 - 18:30',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Via Brere 8', '6598 Tenero'],
    LatLong: {
      lat: 46.1752,
      lng: 8.8551,
    },
  },
  {
    Shop: 'Coop Supermarkt Wil Stadtmarkt',
    'Opening Hours': [
      {
        Tag: 'Montag, Mittwoch - Freitag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Dienstag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Obere Bahnhofstrasse 39', '9500 Will'],
    LatLong: {
      lat: 47.4647,
      lng: 9.0454,
    },
  },
  {
    Shop: 'Coop Supermarkt Seewen Markt',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag, Samstag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 21:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Steinbislin 7', '6423 Seewen'],
    LatLong: {
      lat: 47.0328,
      lng: 8.6281,
    },
  },
  {
    Shop: 'Coop Supermarkt Bulle Le Caro',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '07:30 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '07:30 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '07:30 - 16:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Route de Riaz 50', '1630 Bulle'],
    LatLong: {
      lat: 46.6252,
      lng: 7.0599,
    },
  },
  {
    Shop: 'Coop Supermarkt Burgdorf Sch\u00fctzenmatte',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['S\u00e4gegasse 14', '3400 Burgdorf'],
    LatLong: {
      lat: 47.057,
      lng: 7.6291,
    },
  },
  {
    Shop: 'Coop Supermarkt Rickenbach',
    'Opening Hours': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '08:00 - 20:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Breitestrasse 4', '9532 Rickenbach bei Will'],
    LatLong: {
      lat: 47.447,
      lng: 9.0535,
    },
  },
  {
    Shop: 'Coop Supermarkt Schenkon',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '07:30 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Zellfeld', '6214 Schenkon'],
    LatLong: {
      lat: 47.1783,
      lng: 8.1264,
    },
  },
  {
    Shop: 'Coop Supermarkt City Fribourg Food',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:30 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:30 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 16:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Avenue de la Gare 12', '1700 Fribourg'],
    LatLong: {
      lat: 46.8032,
      lng: 7.1524,
    },
  },
  {
    Shop: 'Coop Supermarkt Dietikon Silbern',
    'Opening Hours': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '08:00 - 21:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Silbernstrasse 9', '8953 Dietikon'],
    LatLong: {
      lat: 47.4187,
      lng: 8.392,
    },
  },
  {
    Shop: 'Coop Supermarkt Z\u00fcrich Sihlcity',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 21:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Kalanderplatz 1', '8045 Z\u00fcrich'],
    LatLong: {
      lat: 47.3577,
      lng: 8.5231,
    },
  },
  {
    Shop: 'Coop Supermarkt Kriens Pilatusmarkt',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '09:00 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '09:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Ringstrasse 19', '6010 Kriens'],
    LatLong: {
      lat: 47.0175,
      lng: 8.2996,
    },
  },
  {
    Shop: 'Coop Supermarkt Thun Str\u00e4ttligen Markt',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Schulstrasse 32', '3604 Thun'],
    LatLong: {
      lat: 46.7403,
      lng: 7.6219,
    },
  },
  {
    Shop: 'Coop Supermarkt Egerkingen G\u00e4upark',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch, Freitag',
        Uhrzeit: '09:00 - 18:30',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '09:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Hausimollstrasse 3', '4622 Egerkingen'],
    LatLong: {
      lat: 47.3181,
      lng: 7.8032,
    },
  },
  {
    Shop: 'Coop Supermarkt Oftringen Perry Center',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Bernstrasse 4', '4665 Oftringen'],
    LatLong: {
      lat: 47.3138,
      lng: 7.9124,
    },
  },
  {
    Shop: 'Coop Supermarkt Bern Wankdorf Center',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Papierm\u00fchlestrasse 85', '3014 Bern'],
    LatLong: {
      lat: 46.9637,
      lng: 7.4653,
    },
  },
  {
    Shop: 'Coop Supermarkt Neuch\u00e2tel La Maladi\u00e8re',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch, Freitag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Rue de la Pierre-\u00e0-Mazel 10', '2000 Neuch\u00e2tel'],
    LatLong: {
      lat: 46.9952,
      lng: 6.9439,
    },
  },
  {
    Shop: 'Coop Supermarkt Riddes',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '07:30 - 18:30',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '07:30 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Rue de Pr\u00e9-Giroud 2', '1908 Riddes'],
    LatLong: {
      lat: 46.1724,
      lng: 7.2214,
    },
  },
  {
    Shop: 'Coop Supermarkt Oberwil M\u00fchlematt',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag ',
        Uhrzeit: '07:30 - 20:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['M\u00fchlemattstrasse 34', '4104 Oberwil'],
    LatLong: {
      lat: 47.508,
      lng: 7.5537,
    },
  },
  {
    Shop: 'Coop Supermarkt Biel Boujean',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Z\u00fcrichstrasse 24C', '2504 Biel'],
    LatLong: {
      lat: 47.1617,
      lng: 7.2943,
    },
  },
  {
    Shop: 'Coop Supermarkt Canobbio Ipermercato Resega',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch, Freitag',
        Uhrzeit: '08:30 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '08:30 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 18:30',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Via Sonvico 5', '6952 Canobbio'],
    LatLong: {
      lat: 46.0283,
      lng: 8.9678,
    },
  },
  {
    Shop: 'Coop Supermarkt Conthey Bassin',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:30 - 18:30',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:30 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Rue de la Madeleine 2', '1964 Conthey'],
    LatLong: {
      lat: 46.2241,
      lng: 7.2965,
    },
  },
  {
    Shop: 'Coop Supermarkt Dietlikon Center',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00 - 21:00',
      },
      {
        Tag: 'Samstag ',
        Uhrzeit: '08:00 - 21:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Industriestrasse 28', '8305 Dietlikon'],
    LatLong: {
      lat: 47.4134,
      lng: 8.6189,
    },
  },
  {
    Shop: 'Coop Supermarkt Heimberg Center',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Bl\u00fcmlisalpstrasse 61', '3627 Heimberg'],
    LatLong: {
      lat: 46.7799,
      lng: 7.6091,
    },
  },
  {
    Shop: 'Coop Supermarkt Hinwil Center',
    'Opening Hours': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '08:00 - 20:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['W\u00e4sseristrasse 38', '8340 Hinwil'],
    LatLong: {
      lat: 47.3066,
      lng: 8.8183,
    },
  },
  {
    Shop: 'Coop Supermarkt La Chaux-de-Fonds Eplatures',
    'Opening Hours': [
      {
        Tag: 'Montag- Mittwoch, Freitag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 -18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Boulevard des Eplatures 20', '2300 La Chaux-de-Fonds'],
    LatLong: {
      lat: 47.0889,
      lng: 6.8021,
    },
  },
  {
    Shop: 'Coop Supermarkt Losone Ipermercato Cattori',
    'Opening Hours': [
      {
        Tag: 'Montag- Mittwoch, Freitag',
        Uhrzeit: '08:30 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '08:30 - 20:00',
      },
      {
        Tag: 'Samstag ',
        Uhrzeit: '08:30 - 18:30',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Via Emmaus 1', '6616 Losone'],
    LatLong: {
      lat: 46.165,
      lng: 8.7688,
    },
  },
  {
    Shop: 'Coop Supermarkt Chur West',
    'Opening Hours': [
      {
        Tag: 'Montag - Freitag',
        Uhrzeit: '09:00 - 20:00',
      },
      {
        Tag: 'Samstag ',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Rasch\u00e4renstrasse 35', '7000 Chur'],
    LatLong: {
      lat: 46.8472,
      lng: 9.5082,
    },
  },
  {
    Shop: 'Coop Supermarkt Aarberg Center',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '07:30 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Bahnhofstrasse 11', '3270 Aarberg'],
    LatLong: {
      lat: 47.0427,
      lng: 7.2759,
    },
  },
  {
    Shop: 'Coop Supermarkt Del\u00e9mont Ticle',
    'Opening Hours': [
      {
        Tag: 'Montag- Mittwoch, Freitag',
        Uhrzeit: '08:00 - 18:30',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '08:00 - 20:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '07:30 - 17:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Route de B\u00e2le 16', '2800 Delemont'],
    LatLong: {
      lat: 47.3665,
      lng: 7.34729,
    },
  },
  {
    Shop: 'Coop Supermarkt Rennaz Riviera',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '07:30 - 19:30',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '07:30 - 20:00',
      },
      {
        Tag: 'Samstag ',
        Uhrzeit: '07:30 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Pr\u00e9-de-la-Croix 18', '1847 Rennaz'],
    LatLong: {
      lat: 46.3843,
      lng: 6.9246,
    },
  },
  {
    Shop: 'Coop Supermarkt Feuerthalen Rhymarkt',
    'Opening Hours': [
      {
        Tag: 'Montag - Samstag',
        Uhrzeit: '08:00 - 20:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Sch\u00fctzenstrasse 30', '8245 Feuerthalen'],
    LatLong: {
      lat: 47.6911,
      lng: 8.6466,
    },
  },
  {
    Shop: 'Coop Supermarkt Villars-sur-Gl\u00e2ne',
    'Opening Hours': [
      {
        Tag: 'Montag - Donnerstag',
        Uhrzeit: '08:00 - 19:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:00 - 21:00',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 16:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Route de Moncor 1', '1752 Villars-sur-Gl\u00e2ne'],
    LatLong: {
      lat: 46.7979,
      lng: 7.1272,
    },
  },
  {
    Shop: 'Coop Supermarkt Vernier Blandonnet Centre',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch',
        Uhrzeit: '08:30 - 19:00',
      },
      {
        Tag: 'Donnerstag',
        Uhrzeit: '08:30 - 21:00',
      },
      {
        Tag: 'Freitag',
        Uhrzeit: '08:30 - 19:30',
      },
      {
        Tag: 'Samstag ',
        Uhrzeit: '08:00 - 18:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Route de Meyrin 171', '1214 Vernier'],
    LatLong: {
      lat: 46.2219,
      lng: 6.0956,
    },
  },
  {
    Shop: 'Coop Supermarkt Allaman Littoral Nouveau',
    'Opening Hours': [
      {
        Tag: 'Montag - Mittwoch',
        Uhrzeit: '08:30 - 19:30',
      },
      {
        Tag: 'Donnerstag - Freitag',
        Uhrzeit: '08:30 - 20:30',
      },
      {
        Tag: 'Samstag',
        Uhrzeit: '08:00 - 19:00',
      },
    ],
    'Delivery Schedule': [
      {
        Tag: 'Montag - Sonntag',
        Uhrzeit: '09:00-12:00 & 13:00-15:00',
      },
    ],
    Address: ['Route de la Gare 10', '1165 Allaman'],
    LatLong: {
      lat: 46.4767,
      lng: 6.4007,
    },
  },
]
